import Layout from '@/layout';
var deviceRouter = {
  path: '/device',
  component: Layout,
  redirect: '/device/index',
  name: 'device',
  meta: {
    title: '设备管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/device/index');
    },
    name: 'index',
    meta: {
      title: '设备管理',
      icon: ''
    }
  }]
};
export default deviceRouter;